export class SiteResponseMessage {
    result: number;
    message: string;
    siteId: string;
    storageId: string | null;
    rowId: string;
}
